import { Component, OnInit } from '@angular/core';
import { AllInOneService } from 'src/app/shared/services/all-in-one.service';

@Component({
  selector: 'app-neo-home',
  templateUrl: './neo-home.component.html',
  styleUrls: ['./neo-home.component.scss']
})
export class NeoHomeComponent implements OnInit {

  constructor( private allinoneService : AllInOneService) { 
    this.allinoneService.navbar = false
  }

  ngOnDestroy(){
    this.allinoneService.navbar = true
  }

  ngOnInit(): void {
  }

}
